//
// locales/vanilla/bn.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/bn.json';
import localeData from 'react-intl/locale-data/bn.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
